const PREFIX = "rdv-scroll:";

const MEMBER_MAIN_SELECTOR = '[data-testid="member-main-scroll"]';

/** Clé stable pour la liste (sans paramètre `dossier`). */
export function listScrollKey(pathname, search = "") {
  const sp = new URLSearchParams(String(search).replace(/^\?/, ""));
  sp.delete("dossier");
  const q = sp.toString();
  const path = pathname || "/";
  return `${path}${q ? `?${q}` : ""}`;
}

function readSlot(key) {
  try {
    return sessionStorage.getItem(`${PREFIX}${key}:slot`) || "window";
  } catch {
    return "window";
  }
}

function getScrollTarget(slot) {
  if (slot === "main") {
    const main = document.querySelector(MEMBER_MAIN_SELECTOR);
    if (main) return { el: main, slot: "main" };
  }
  return { el: document.documentElement, slot: "window" };
}

function readY(el, slot) {
  return slot === "main" ? el.scrollTop : window.scrollY;
}

function writeY(el, slot, y) {
  if (slot === "main") el.scrollTop = y;
  else window.scrollTo({ top: y, left: 0, behavior: "auto" });
}

/** Sauvegarde la position avant d’ouvrir une fiche annonce. */
export function saveScrollForList(key) {
  if (!key || typeof window === "undefined") return;
  try {
    const main = document.querySelector(MEMBER_MAIN_SELECTOR);
    const useMain = Boolean(main && main.scrollHeight > main.clientHeight + 4);
    const slot = useMain ? "main" : "window";
    const { el } = getScrollTarget(slot);
    const y = readY(el, slot);
    sessionStorage.setItem(`${PREFIX}${key}`, String(Math.max(0, Math.round(y))));
    sessionStorage.setItem(`${PREFIX}${key}:slot`, slot);
  } catch {
    /* quota / mode privé */
  }
}

/**
 * Restaure la position enregistrée (plusieurs tentatives : liste async, layout membre).
 * @returns {boolean} true si une position a été restaurée
 */
export function restoreScrollForList(key, { maxAttempts = 16, delayMs = 50 } = {}) {
  if (!key || typeof window === "undefined") return false;
  let raw;
  let slot;
  try {
    raw = sessionStorage.getItem(`${PREFIX}${key}`);
    slot = readSlot(key);
    if (raw == null) return false;
    sessionStorage.removeItem(`${PREFIX}${key}`);
    sessionStorage.removeItem(`${PREFIX}${key}:slot`);
  } catch {
    return false;
  }

  const y = Number(raw);
  if (!Number.isFinite(y) || y < 0) return false;

  let attempts = 0;
  const tryOnce = () => {
    const { el, slot: s } = getScrollTarget(slot);
    writeY(el, s, y);
    const current = readY(el, s);
    if (Math.abs(current - y) <= 3 || attempts >= maxAttempts) return;
    attempts += 1;
    window.setTimeout(tryOnce, delayMs);
  };

  tryOnce();
  requestAnimationFrame(tryOnce);
  return true;
}
